import { SearchBy } from '@shared/base-search-bar/entities/search.entities';
import { flightResultsRootRoute } from '@flight-results/flight-results-routing.constants';
import { HOTEL_RESULTS_ROUTE, HOTEL_BYHOURS_RESULTS_ROUTE } from '@hotels/hotel-results/constants/routes';
import { packagesResultRootRoute } from '@packages/packages-result/constants/packages-result.routes';
import { activitiesHomeRootRoute } from '@activities/constants/activities.routes';
import { busResultsBaseRoute } from '@buses/bus-results/constanst/bus-routes.constants';
import { autoHomeRootRoute } from '@app/modules/autos/auto-home/constants/routes';

export function searchByDeeplink(deeplink: string): SearchBy | null {
  switch (true) {
    case deeplink.includes(flightResultsRootRoute):
      return SearchBy.FLIGHTS;
    case deeplink.includes(HOTEL_RESULTS_ROUTE):
    case deeplink.includes(HOTEL_BYHOURS_RESULTS_ROUTE):
      return SearchBy.HOTELS;
    case deeplink.includes(packagesResultRootRoute):
      return SearchBy.PACKAGES;
    case deeplink.includes(autoHomeRootRoute):
      return SearchBy.AUTOS;
    case deeplink.includes(activitiesHomeRootRoute):
      return SearchBy.ACTIVITIES;
    case deeplink.includes(busResultsBaseRoute):
      return SearchBy.BUSES;
    default:
      return null;
  }
}
